// The day a calendar event falls on, where the user is. An iCal source sends
// an all-day event as midnight UTC on its date (worker/parsers.ts), so it is
// that date anywhere; a timed event keeps its own moment.

export function eventDay(e: { t?: number | null; value?: unknown }): Date {
  const at = new Date(e.t ?? 0);
  return e.value === "all-day" ? new Date(at.getUTCFullYear(), at.getUTCMonth(), at.getUTCDate()) : at;
}

/**
 * The next events, in the order they happen where the user is: an all-day
 * event from the start of its own day, first among that day's events, and
 * kept for the whole of the day; a timed one until an hour after it starts.
 * The stream's own order is UTC's, where an all-day event sits at midnight
 * UTC: the evening before, west of UTC, and mid-morning east of it.
 */
export function upcomingEvents<E extends { t?: number | null; value?: unknown }>(events: E[], now: number, max = 4): E[] {
  const d = new Date(now);
  const today = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  return events
    .filter((e) => !!e.t && (e.value === "all-day" ? eventDay(e).getTime() >= today : e.t >= now - 3_600_000))
    .map((e, i) => ({ e, i, at: eventDay(e).getTime(), day: e.value === "all-day" ? 0 : 1 }))
    .sort((a, b) => a.at - b.at || a.day - b.day || a.i - b.i)
    .slice(0, max)
    .map((x) => x.e);
}
